import React, { useContext } from "react";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import CarouselLibrary from "./CarouselLibrary";
import { premiseHealthLogoData, premiseHealthBackgroundData, premiseHealthLowerThirdsData, premiseHealthOutroData } from "./assets";

interface PremiseHealthCarouselsProps {
  onAssetClick: (asset: Record<string, any>) => Promise<void>;
}

const PremiseHealthCarousels: React.FC<PremiseHealthCarouselsProps> = ({ onAssetClick }) => {
  const { data: { mediaType } } = useContext(CreatomateContext);

  return (
    <>
      <div>
        <CarouselLibrary
          assets={premiseHealthLogoData}
          className="library-logo align-left"
          onAssetClick={onAssetClick}
          title="Logos"
        />
      </div>
      <div>
        <CarouselLibrary
          assets={premiseHealthBackgroundData}
          className="library-background align-left"
          onAssetClick={onAssetClick}
          title="Background"
        />
      </div>
      <div>
        <CarouselLibrary
          assets={
            mediaType === VIDEO_TYPE
              ? premiseHealthLowerThirdsData
              : premiseHealthLowerThirdsData.map(lowerThirdData => ({
                ...lowerThirdData,
                animations: undefined
              }))
          }
          className="library-lower-thirds align-left"
          onAssetClick={onAssetClick}
          title="Lower Thirds"
        />
      </div>
      {mediaType === VIDEO_TYPE && (
        <div>
          <CarouselLibrary
            assets={premiseHealthOutroData}
            className="library-outro align-left"
            onAssetClick={onAssetClick}
            title="Outro"
            videoAssets
          />
        </div>
      )}
    </>
  );
};

export default PremiseHealthCarousels;
